// extracted by mini-css-extract-plugin
export var component = "ContentNodeCard-module--component--khMye";
export var excerpt = "ContentNodeCard-module--excerpt--Mn2Op";
export var isCompact = "ContentNodeCard-module--isCompact--KWEpM";
export var mediaWrapper = "ContentNodeCard-module--mediaWrapper--6P6cC";